/**
 * Created by DELL on 2018/4/16.
 */
import * as types from '../constants/ActionTypes'
import api from '../utils/api'

let getSafetyMechanismList=(data)=>{
    let url = '/lossAss/organizitions/page'+ '?pageIndex=' + data.pageIndex + '&pageSize='+data.pageSize
    if(data.searchTenant){
        url+='&searchTenant='+data.searchTenant
    }

    return dispatch => {
        return api(url)
            .get()
            .then(result=>dispatch(getSafetyMech_finish(result)))
            .catch(err=>dispatch(getSafetyMech_finish({errCode:-1})))
    }
}
let getSafetyMech_finish=(result)=>{

    if(result.errCode==0){
        return{
            type:types.SAFETY_MECHANISM_LIST,
            payload:{
                list:result.result.list,
                count:result.result.count,
                pageIndex:result.result.pageIndex,
                pageSize:result.result.pageSize,
                province:result.result.params.province,
                city:result.result.params.city
            }
        }
    }else {
        return{
            type:types.SAFETY_MECHANISM_LIST,
            payload:{},
            error:true
        }
    }
}


export default {
    getSafetyMechanismList
}